import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {TranscriptPresetsPanelProps} from '@Panels/transcript-presets-panel/transcript-presets-panel.types';

export const openTranscriptPresetsModal = (props?: TranscriptPresetsPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.TRANSCRIPT_PRESETS_MODAL,
      panelProps: {...props},
    })
  );
};
